// 会员特权相关
import { computed, Ref } from 'vue'

export const usePlayTimePrivilege = (
  user: Ref<API_DEVICE.UserInfo | undefined>,
  config: Ref<API_DEVICE.BaseConfig | null>,
  scene: 'nfo' | 'download_list',
  isMobile: boolean,
) => {
  /**
   * 会员身份
   */
  const vip = computed(() => {
    const vipInfo = user.value?.vip
    return vipInfo?.is_vip ? (vipInfo.vastype ?? '0') : '0'
  })

  /**
   * 可播放次数的配置
   */
  const timesConfig = computed(() => config.value?.file_play_by_scene?.[scene]?.total_count_by_vastype)

  /**
   * 表格中展示的特权
   */
  const privilegeTable = computed(() => {
    const parseTimes = (times?: number) => {
      if (times === -1) {
        return '无限制'
      } else {
        return `${times ?? 0}次/天`
      }
    }
    return {
      normal: parseTimes(timesConfig.value?.[0]),
      vip: parseTimes(timesConfig.value?.[3]),
      svip: parseTimes(timesConfig.value?.[5]),
    }
  })

  /**
   * 副标题描述 
   */
  const privilegeDescription = computed(() => {
    const targetIdentity = user.value?.vip?.is_vip ? '超级会员' : '白金会员'  // 提示用户开通的会员身份，会员提示开超会，非会员提示开白金。
    const times = targetIdentity === '白金会员' ? (timesConfig.value?.[3] ?? 0) : (timesConfig.value?.[5] ?? 0)
    if (times <= -1) { // 如果不限制次数
      return `${targetIdentity}${isMobile ? '手机' : ''}播放次数无限制`
    }
    return `${targetIdentity}可以${isMobile ? '手机' : ''}播放${times}次视频`
  })

  const buttonInfo = computed(() => {
    if (vip.value === '0') { // 用户当前为非会员，提示开白金会员
      return {
        button: '开通会员',
        buttonClass: 'vip',
      }
    } else if (vip.value === '3') {// 用户当前为白金会员，提示升级超级会员
      return {
        button: '升级超级会员',
        buttonClass: 'svip',
      }
    }
    return {
      button: '开通会员',
      buttonClass: 'svip',
    }
  })

  return {
    buttonInfo,
    privilegeDescription,
    privilegeTable,
  }
}